import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { LucideAngularModule, ServerCrash } from "lucide-angular";
import { ShellService } from "../../services/shell.service";
import { ShellDefaultUifComponent } from "./ui-fragments/shell-default-uif/shell-default-uif.component";
import { ShellHiddenUifComponent } from "./ui-fragments/shell-hidden-uif/shell-hidden-uif.component";
import { HttpErrorInterceptor } from "../../interceptors/http-error.interceptor";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "app-shell-uif",
  imports: [LucideAngularModule, CommonModule, ShellDefaultUifComponent, ShellHiddenUifComponent, TranslocoDirective],
  templateUrl: "./shell-uif.component.html",
  styles: ``,
})
export class ShellUifComponent {
  //#region Fields
  shellService = inject(ShellService);
  translocoService = inject(TranslocoService);
  isOffline = HttpErrorInterceptor.API_OFFLINE;
  errorIcon = ServerCrash;
  countdown = HttpErrorInterceptor.countdown;
  //#endregion
}
